import React from "react";
import { useTranslation } from "react-i18next";
import useGet from "src/hooks/rest/useGet";
import { ApiBadge } from "src/api/types";
import FlatList from "src/components/FlatList";
import ProfileBadge from "src/components/ProfileBadge/ProfileBadge";

interface ResumeBadgesProps {
	// badges: ApiBadge[];
	query: string;
}

const ResumeBadges = ({ query }: ResumeBadgesProps) => {
	const { t } = useTranslation("resume", {
		keyPrefix: "resume-badges",
	});
	const [{ data: badges }, loading] = useGet(query);
	return (
		<FlatList
			columns={1}
			empty={{
				title: t("empty.title"),
			}}
			gap={16}
			{...{ loading }}
			data={badges || []}
			renderItem={(item: ApiBadge) => (
				<ProfileBadge
					variant={
						badges?.length === 1 ? "resume-list" : "resume-list"
					}
					key={item.type}
					badge={item}
				/>
			)}
		/>
	);
};

export default ResumeBadges;
